"use client";
import * as React from "react";
const SvgArrowForwardOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0 6.59 1.41 12.17 7H0v2h12.17l-5.58 5.59L8 16l8-8z" }));
export {
  SvgArrowForwardOutlined as default
};
